import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: 1,
  value: 490,
  title: 'Checklists de Seguridad para Resina',
  image: 'https://cdn.magicpatterns.com/uploads/kE7bNKrwCBeASnsgsedJWi/mocap_cheklis_de_seguridad.png'
}, {
  num: 2,
  value: 390,
  title: 'El Arte de Vender',
  image: 'https://cdn.magicpatterns.com/uploads/2N3FxscC6M8p4kFoHmuXZS/mocap_el_arte_de_vender.png'
}, {
  num: 3,
  value: 290,
  title: 'Lámparas con Resina',
  image: 'https://cdn.magicpatterns.com/uploads/dKwKtv5LZJwB9TETyVjhkw/mocap_lamparas.png'
}, {
  num: 4,
  value: 350,
  title: 'Elaboración de Moldes Caseros',
  image: 'https://cdn.magicpatterns.com/uploads/bYaCSpvmS3iiiUKEVWbQsE/mocap_moldes.png'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function BonusesSection() {
  return <section className="py-[48px] md:py-[80px] px-4 md:px-5 bg-[#FFFBEB] relative" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-8 md:mb-12" data-id="element-43">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-4 md:mb-6 flex items-center justify-center gap-3 md:gap-4" data-id="element-44">
            <GiftIcon className="w-6 h-6 md:w-8 md:h-8 text-[#C9A84C]" data-id="element-45" />
            LOS BONOS
          </h2>
          <p className="text-subtitle text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-46">
            Al comprar hoy recibís el ebook completo más estos{' '}
            <span className="underline-gold text-[#92400E]" data-id="element-47">4 bonos</span>:
          </p>
          <div className="w-20 md:w-24 h-1 bg-[#C9A84C]/30 mx-auto mt-4 md:mt-6" data-id="element-48"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="flex flex-col gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-49">
          {bonuses.map(bonus => <motion.div key={bonus.num} variants={itemVariants} className="card-light border border-[#FDE68A] px-4 py-4 md:px-7 md:py-6 hover:border-[#C9A84C] hover:shadow-md transition-all duration-300 flex flex-row gap-4 md:gap-6 items-center" data-id="element-50">
              {/* Bonus Image */}
              <div className="w-16 h-16 md:w-24 md:h-24 shrink-0 rounded-lg overflow-hidden shadow-sm bg-gray-100" data-id="element-51">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-52" />
              </div>

              {/* Content */}
              <div className="flex-grow min-w-0" data-id="element-53">
                <h3 className="text-sm md:text-lg font-bold text-[#92400E] mb-0.5 md:mb-1" data-id="element-54">
                  <span className="underline-gold" data-id="element-55">BONO {bonus.num}</span>
                </h3>
                <p className="text-gray-700 font-medium text-sm md:text-base mb-1.5 md:mb-3 leading-snug" data-id="element-56">
                  {bonus.title}
                </p>
                <div className="text-sm md:text-base font-medium flex items-center gap-2 flex-wrap" data-id="element-57">
                  <span className="text-gray-500 hidden sm:inline" data-id="element-58">
                    Valor:{' '}
                  </span>
                  <span className="line-through decoration-red-500/60 text-gray-400 hidden sm:inline" data-id="element-59">
                    ${bonus.value}
                  </span>
                  <span className="font-bold text-[#16A34A] text-base md:text-lg" data-id="element-60">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Total Value Box */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="card-light border-2 border-[#C9A84C] px-5 py-6 md:p-8 text-center shadow-lg bg-white" data-id="element-61">
          <p className="text-sm md:text-lg text-gray-500 mb-1.5 md:mb-2" data-id="element-62">
            Valor total de los bonos:{' '}
            <span className="line-through decoration-red-500/60" data-id="element-63">$1.520</span>
          </p>
          <p className="text-2xl md:text-4xl font-bold text-[#16A34A] font-heading" data-id="element-64">
            HOY: GRATIS con tu compra
          </p>
        </motion.div>
      </div>
    </section>;
}